/* eslint-disable import/first */
import React, { useState, useEffect } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { Box, Button, Paper, IconButton, InputBase, Grid } from '@material-ui/core';
import Skeleton from 'react-loading-skeleton';
import { useNavigate, useLocation } from '@reach/router';
import { FormattedMessage, useIntl } from 'react-intl';
const { fetchAddress, selectAddress, deleteAddress, validateLocation } = Slices.addressSlice;
const { sendCart, clearCart } = Slices.cartSlice;
const { clearCustomizeItems } = Slices.tempCartSlice;
const { selectFirstMenu, clearMenu, fetchMenu } = Slices.menuSlice;
const { selectCountryValidations, getClusterId, getHomeJsonComponents } = Slices.configSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { clearCategory } = Slices.categorySlice;
const { clearProductState } = Slices.productSlice;
const { fetchHome } = Slices.homeSlice;
const { clearFavo } = Slices.favouriteSlice;

import AddressItem from './AddressItem';
// import NoAddress from './NoAddress';
import css from './index.module.scss';
import debounce from 'lodash/debounce';
import 'react-loading-skeleton/dist/skeleton.css';
import { RiSearch2Line } from '@react-icons/all-files/ri/RiSearch2Line';
import { IoMdWarning } from '@react-icons/all-files/io/IoMdWarning';
import { IoMdClose } from '@react-icons/all-files/io/IoMdClose';
import { Gps } from './icons';
const { selectDesktop } = Slices.appSlice;
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import NoAddress from './NoAddress';
import CountrySelection from '../CountryDropdown';
import DialogBox from '../DialogBox';

import { capitalizeFirstLetter, getCurrentBrand } from 'spwa-ui-library/esm/utils/helper';

const SavedAddress = ({ closePopUp, onSelect, setStatus, showAction, myAddress }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { action = '' } = location.state || {};
  const isDesktop = useSelector(selectDesktop);
  const clusterId = useSelector(getClusterId);
  const [loadState, setLoadStatus] = useState(true);
  const [cartDropPopup, setCartDropPopup] = useState(false);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const countryName = useSelector(selectCurrentCountry);
  const offer = useSelector((state) => state.offer);
  const countryValidations = useSelector((state) => selectCountryValidations(state, countryName));
  const [locationStatus, setLocationStatus] = useState(true);
  const [showMoreAddress, setShowMoreAddress] = useState(false);
  const intl = useIntl();
  const couponCode = offer.apply ? offer.apply.couponCode : '';
  const searchLocation = intl.formatMessage({ id: 'addaddress_searchlocation' });
  const menu = useSelector(selectFirstMenu);

  useEffect(() => {
    if (loadState) {
      const timeout = setTimeout(() => {
        dispatch(fetchAddress()).then((resp) => {
          setLoadStatus(false);
        });
      }, 500);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [dispatch, loadState]);
  const cart = useSelector((state) => state.cart);
  const profile = useSelector((state) => state.profile);
  const address = useSelector((state) => state.address);
  const [open, setOpen] = React.useState(false);
  const [errMsg, setErrMsg] = React.useState('');
  let allAddress = 0;
  if (address.data && address.data.info) {
    allAddress = Object.entries(address.data.info).length;
  }

  const blobURL = useSelector(getHomeJsonComponents);

  const selectaddress = (addressid) => {
    const selectedIndex = address.data.info.findIndex(({ id }) => id === addressid);
    const addressObj = address.data.info[selectedIndex];
    let menuID = addressObj?.menuId;
    let tempID = addressObj?.menuTemplateId;
    if (tempID != menu?.menuTemplateId || menuID != menu?.menuId) {
      dispatch(clearCategory());
      dispatch(clearProductState());
      dispatch(clearMenu());
      dispatch(clearCart());
      dispatch(clearFavo());
      dispatch(clearCustomizeItems());

      const homePayload = {
        cluster: clusterId,
      };

      const menuPayload = {
        cluster: clusterId,
        blob: blobURL,
        country: countryName.toUpperCase(),
        brand: getCurrentBrand(),
        lang: capitalizeFirstLetter(intl.locale),
        defMenu: menuID,
        menu: tempID,
      };

      const cartPayload = {
        body: {
          addressSubType: 'DELIVERY',
          addressType: 'DELIVERY',
          addressId: address?.id || '',
          cartId: profile.data.data[0].cartId,
          applySurprisePromo: false,
          clusterId: clusterId,
          items: [],
          version: 'v20',
          orderType: 'DELIVERY',
          storeId: address?.storeId,
        },
        headers: { country: profile.data.data[0].country },
      };

      dispatch(sendCart(cartPayload)).then(() => {
        Promise.allSettled([
          dispatch(fetchHome(homePayload)),
          dispatch(fetchMenu(menuPayload)),
          dispatch(selectAddress(addressObj)),
        ]).then(() => {
          window.localStorage.setItem('_add', JSON.stringify(addressObj));
          window.location.href = `/home`;
        });
      });
    } else {
      dispatch(selectAddress(addressObj));
      window.localStorage.setItem('_add', JSON.stringify(addressObj));
      if (action === 'select' && !isDesktop) {
        updateCart(addressObj);
        navigate(`/${intl.locale}/checkout`, { replace: true });
      } else if (isDesktop) {
        updateCart(addressObj);
        setTimeout(() => {
          navigate(-1);
        }, 0);
      } else {
        updateCart(addressObj);
        navigate(`/${intl.locale}/home`);
      }
    }
  };

  const choseAddress = (addressid) => {
    onSelect && onSelect();
    if (cart.data.items.length) {
      const selectedIndex = address.data.info.findIndex(({ id }) => id === addressid);
      const addressObj = address.data.info[selectedIndex];
      let menuID = addressObj?.menuId;
      let tempID = addressObj?.menuTemplateId;

      const payload = {
        lat: addressObj.lat,
        lng: addressObj.lng,
        screen: 'HOME',
        addressSubType: 'DELIVERY',
      };

      dispatch(validateLocation(payload)).then((resp) => {
        if (!resp.error) {
          tempID =
            resp?.payload?.data?.data?.menuTempId ||
            resp?.payload?.data?.data?.menuTemplateId ||
            tempID;
          menuID = resp?.payload?.data?.data?.menuId || menuID;
        }
      });
      if (
        (tempID != menu?.menuTemplateId || menuID != menu?.menuId) &&
        cart?.data?.items?.length > 0
      ) {
        setCartDropPopup(true);
        setSelectedAddressId(addressid);
      } else {
        selectaddress(addressid);
      }
    } else {
      selectaddress(addressid);
    }
  };

  const updateCart = (value) => {
    const payload = {
      body: {
        addressSubType: 'DELIVERY',
        addressType: 'DELIVERY',
        addressId: value?.id || '',
        cartId: profile.data.data[0].cartId,
        applySurprisePromo: couponCode?.length > 0,
        couponCode: couponCode,
        clusterId: clusterId || '',
        items: cart.data.items,
        version: 'v20',
        orderType: 'DELIVERY',
        storeId: value?.storeId,
      },

      headers: {
        country: profile.data.data[0].country,
      },
    };
    dispatch(sendCart(payload)).then((resp) => {
      if (resp.error) {
        setOpen(true);
        setErrMsg(resp.error.message);
      }
      if (resp.meta.requestStatus !== 'rejected') {
        return true;
      }
    });
  };

  const delAddress = (id) => {
    const payload = { addressId: id };
    dispatch(deleteAddress(payload)).then((resp) => {
      dispatch(fetchAddress());

      // if it is saved as default in localstorage, remove it.
      const localStorageAddress = JSON.parse(localStorage.getItem('_add'));
      if (localStorageAddress?.id == id) {
        localStorage.removeItem('_add');
      }
    });
  };

  const handleAddAddress = () => {
    window.localStorage.removeItem('addressType');
    if (isDesktop) {
      navigate(`${location.pathname}?modal=addaddress`);
    } else {
      navigate(`/${intl.locale}/addAddress/${action}`, {
        replace: true,
        state: {
          oldLocation: JSON.parse(JSON.stringify(location)),
        },
      });
    }
  };
  const handleNewAddress = (updateDefaultAddress = true) => {
    if (!isDesktop) {
      navigate(
        `/${intl.locale}/addAddress/${action}${updateDefaultAddress ? '' : '?no-update=true'}`,
        {
          replace: true,
          state: {
            oldLocation: location.state.oldLocation,
          },
        }
      );
    } else {
      navigate(
        `${location?.state?.oldLocation?.pathname || `/${intl.locale}/home`}?modal=addaddress`
      );
    }
  };
  React.useEffect(() => {
    try {
      navigator.geolocation.getCurrentPosition(
        (i) => setLocationStatus(true),
        (i) => setLocationStatus(false)
      );
    } catch (err) {
      console.log(err);
    }
  }, []);

  React.useEffect(() => {
    const error = localStorage.getItem('editAddressError');
    if (error) {
      setOpen(true);
      setErrMsg(error);
      localStorage.removeItem('editAddressError');
    }
  }, [address]);

  if (loadState) {
    return (
      <Box sx={{ padding: '10px' }}>
        <Skeleton count={3} className={css.Skeleton} height={50} />
      </Box>
    );
  }
  if (!allAddress && !loadState) {
    // navigate(`${location.pathname}?modal=addaddress`);
    // return <AddAddress />;
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  if (address.data.info && address.data.info.length === 0 && !myAddress && !isDesktop) {
    navigate(`/${intl.locale}/addAddress/${action}`, {
      replace: true,
      state: { oldLocation: JSON.parse(JSON.stringify(location)) },
    });
  }
  if (address.data.info && address.data.info.length === 0 && myAddress) {
    return <NoAddress action={action} />;
  }
  const handleDropPopup = () => {
    setCartDropPopup(false);
  };
  return (
    <>
      <div className={css.root}>
        {!location.pathname.match('addresses') && (
          <div className={css.desktopHeader}>
            <div className={css.heading}>
              <FormattedMessage
                id="header_delivery_heading"
                defaultMessage="Select Delivery Location"
              />
            </div>
            <div className={css.Closebutton}>
              <Button onClick={closePopUp}>
                <IoMdClose />
              </Button>
            </div>
          </div>
        )}
        <div className={css.wrapper}>
          {!myAddress ? (
            <>
              <Grid className={css.locationSearchArea}>
                <Paper>
                  <Grid className={css.locationSearch} onClick={handleAddAddress}>
                    <IconButton className={css.searchIcon}>
                      <RiSearch2Line />
                    </IconButton>
                    <InputBase
                      placeholder={searchLocation}
                      inputProps={{ 'aria-label': 'search google maps' }}
                      className={css.locationInput}
                    />
                    <IconButton className={css.locationIcon}>
                      <Gps />
                    </IconButton>
                  </Grid>
                </Paper>
                {!locationStatus && (
                  <div className={css.locationDenied}>
                    <div className={css.icon}>
                      <IoMdWarning />
                    </div>
                    <FormattedMessage
                      id="addressList_locationBlocked"
                      defaultMessage="Oops! Seems location is blocked. Change your location settings in browser or
                    select location manually"
                    />
                  </div>
                )}
              </Grid>

              <div className={css.subHeading}>
                <div className={css.title}>
                  <FormattedMessage
                    id="addresslist_savedaddresses"
                    defaultMessage="Saved Addresses"
                  />
                </div>
                <Button onClick={handleAddAddress} className={css.addNewAddress}>
                  <FormattedMessage
                    id="addresslist_addnew_my_profile"
                    defaultMessage="Add New Address"
                  />
                </Button>
              </div>
            </>
          ) : (
            <div className={css.heading}>
              <CountrySelection onlyChangeButton={true} />
            </div>
          )}
          <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
          >
            <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
              {errMsg}
            </Alert>
          </Snackbar>
          {/* {address.data.info.map((value, index) => (
        <AddressItem
          key={index}
          showAction={showAction}
          itemData={value}
          onSelect={() => choseAddress(value.id)}
          onDelete={() => delAddress(value.id)}
        />
      ))} */}

          {(address?.data?.info || []).map(
            (value, index) =>
              index <= 2 && (
                <AddressItem
                  myAddress={myAddress}
                  showAction={showAction}
                  itemData={value}
                  onSelect={() => choseAddress(value.id)}
                  onDelete={() => delAddress(value.id)}
                />
              )
          )}
          {!myAddress && (
            <div className={css.changeCountry}>
              <CountrySelection onlyChangeButton={true} />
            </div>
          )}
          {address.data.info.length > 3 ? (
            <>
              <Button
                onClick={() => setShowMoreAddress(!showMoreAddress)}
                className={css.addMoreAddress}
              >
                <FormattedMessage
                  id={showMoreAddress ? 'hidemore_address' : 'showmore_address'}
                  defaultMessage="Show More Address"
                />
              </Button>
              <div className={css.displayMoreAddress}>
                {showMoreAddress &&
                  address.data.info
                    .slice(3)
                    .map((value, index) => (
                      <AddressItem
                        myAddress={myAddress}
                        showAction={showAction}
                        itemData={value}
                        onSelect={() => choseAddress(value.id)}
                        onDelete={() => delAddress(value.id)}
                      />
                    ))}
              </div>
            </>
          ) : null}
        </div>
        {myAddress && (
          <div className={css.addAddressButton}>
            <Button
              className={css.addAddress}
              onClick={() => {
                handleNewAddress(false);
              }}
            >
              <FormattedMessage id="addresslist_addnew" defaultMessage="Add Address" />
            </Button>
          </div>
        )}
      </div>
      {cartDropPopup && (
        <ChangeLocationConfirm
          isOpen={cartDropPopup}
          onCancel={handleDropPopup}
          onConfirm={() => {
            window.localStorage.setItem('menuUpdate', 'true');
            selectaddress(selectedAddressId);
          }}
        />
      )}
    </>
  );
};

export default SavedAddress;

export function ChangeLocationConfirm({
  isOpen = false,
  onCancel = () => {},
  onConfirm = () => {},
}) {
  const intl = useIntl();

  return (
    <DialogBox
      title={intl.formatMessage({ id: 'DropPopup_changeLocation' })}
      size="sm"
      hideCloseButton={true}
      isOpen={isOpen}
      onClose={onCancel}
    >
      <div className={css.dropcart}>
        <div className={css.content}>{intl.formatMessage({ id: 'DropPopup_content' })}</div>
        <div className={css.action}>
          <Button onClick={onCancel} variant="outlined">
            {intl.formatMessage({ id: 'DropPopup_buttonCancel' })}
          </Button>
          <Button onClick={onConfirm} variant="contained" color="primary">
            {intl.formatMessage({ id: 'DropPopup_buttonProceed' })}
          </Button>
        </div>
      </div>
    </DialogBox>
  );
}
